if (!NodeList.prototype.map)
NodeList.prototype.forEach = function(callback) {
  for (var i = 0; i < this.length; i++) {
    callback(this[i]);
  }
};

try {
  window.localStorage.test = 1;
  window.localStorageIsUsable = true;
} catch(err) {
  window.localStorageIsUsable = false;
  console.log(err);
}

window.GOAL = {
  meters: 1000,
  feet: 3300
};



// WEBPACK FOOTER //
// ./src/assets/javascripts/utils.js